module.exports = __webpack_public_path__ + "static/media/farming1.5b0ed201.png";